<template>
  <div class="flex flex-col justify-center text-center font-sans-serif" v-if="slot">
    <span v-if="!notShowTitle">{{$t('payments.booking-summary-lesson')}}</span>
    <span class="font-bold text-2xl">{{ slot.day }} </span>
    <span>{{$t('bookingSlots.from')}} <strong class="text-xl">{{ slot.timeStart}}</strong>
    {{$t('bookingSlots.to')}} <strong class="text-xl">{{ slot.timeEnd }}</strong></span>
    <div class="flex justify-center items-center">
      <span class="pt-3 pr-2">{{$t('bookedLessonsDashboard.with')}}</span>
      <strong class="text-2xl text-orange-academy-100">{{ slot.teacher_name }}</strong>
    </div>
    <span class="pt-1">{{$t('payments.booking-summary-price')}}
    <strong class="text-xl pl-1">{{ formatter.format(lesson.total_to_pay/100) }}</strong></span>
  </div>
</template>

<script>
import DatesConversion from '@/mixins/DatesConversion';

export default {
  props: ['lesson', 'notShowTitle'],

  mixins: [DatesConversion],

  computed: {
    slot() {
      const currentSlot = this.lesson.slot;
      if (currentSlot) {
        currentSlot.teacher = this.lesson.teacher;
        return this.convertBookedSlotToBePrintedOnDashboard(currentSlot, 'student');
      }
      return null;
    },
  },
};
</script>
